import React from "react";
import axiosInstance from "../auth/axiosInstance";
import { useIsAuthenticated } from "@azure/msal-react";

export const useGlobalState = (user) => {

  const [data, setData] = React.useState({
    siteData: { endpoint: 'sites', data: [] },
    countData: { endpoint: 'count', data: [] },
    logsData: { endpoint: 'logs', data: [] },
    clientsData: { endpoint: 'clients/rack', data: [] },
    dashData: { endpoint: 'count/site/getall', data: [] },
  });
  const isAuthenticated = useIsAuthenticated()
  const fetchData = async (endpoint, key, set) => {
    try {
      const headers = {};
      if (!!user) {
        headers['x-site'] = user?.Type === 'Admin' || user?.Type === 'View Only' ? undefined : JSON.stringify(user.Site);
      }

      const response = await axiosInstance(endpoint, { headers });

      setData((prevData) => ({
        ...prevData,
        [key]: {
          endpoint: endpoint,
          data: response.data,
        },
      }));
      if (set) {
        set(response.data)
      }
    } catch (error) {
      console.error(`Erro ao buscar dados para ${key}:`, error);
    }
  };

  function getInitialData() {
    Object.entries(data).forEach(([key, value]) => {
      fetchData(value.endpoint, key);
    });
  }
  React.useEffect(() => {
    if (isAuthenticated) {
      getInitialData();
    }
  }, [user]);

  return {
    siteData: data.siteData.data,
    countData: data.countData.data,
    dashData: data.dashData.data,
    logsData: data.logsData.data,
    clientsData: data.clientsData.data,
    fetchData: fetchData,
  };

};
